// extracted by mini-css-extract-plugin
export default {"button":"ButtonOption_button__1shJV","buttonActive":"ButtonOption_buttonActive__OFoya","buttonInactive":"ButtonOption_buttonInactive__AmkTB"};